import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "./api";
import { Btn, ConfirmDialog } from "./atoms";

export default function ShowcaseListPage() {
  const [items, setItems] = useState(null);
  const [confirmDel, setConfirmDel] = useState(null);
  const nav = useNavigate();

  const refresh = () => api.showcaseList().then(setItems);
  useEffect(() => { refresh(); }, []);

  const onCreate = async () => {
    const slug = `new-case-${Date.now().toString(36)}`;
    await api.showcaseCreate({ slug, name: "Untitled case study" });
    nav(`/admin/showcase/${slug}`);
  };
  const onDuplicate = async (slug) => {
    const dup = await api.showcaseDuplicate(slug);
    nav(`/admin/showcase/${dup.slug}`);
  };
  const onDelete = async () => {
    await api.showcaseDelete(confirmDel.slug);
    setConfirmDel(null);
    refresh();
  };

  return (
    <div data-testid="admin-showcase-list">
      <div className="flex items-center justify-between gap-4 mb-9">
        <div>
          <div className="text-[0.62rem] font-bold tracking-[0.3em] uppercase text-[#F4D64E]">Showcase</div>
          <h1 className="mt-3 font-display text-3xl font-black tracking-[-0.025em]">Case studies</h1>
        </div>
        <Btn onClick={onCreate} data-testid="cs-new">＋ New case study</Btn>
      </div>

      {items === null ? (
        <div className="text-sm text-neutral-500">Loading…</div>
      ) : (
        <ul className="divide-y divide-white/[0.06] border border-white/[0.06] rounded-xl overflow-hidden">
          {items.map((p) => (
            <li
              key={p.slug}
              className="flex items-center gap-5 px-5 py-4 bg-[#0F141A] hover:bg-[#13191F] transition-colors"
              data-testid={`cs-row-${p.slug}`}
            >
              <span className="text-[0.65rem] font-bold tracking-[0.22em] uppercase text-[#F4D64E] tabular-nums shrink-0 w-10">
                {p.n || "—"}
              </span>
              <div className="flex-1 min-w-0">
                <Link
                  to={`/admin/showcase/${p.slug}`}
                  className="font-bold text-white hover:text-[#F4D64E] transition-colors block truncate"
                >
                  {p.name}
                </Link>
                <div className="text-[0.7rem] text-neutral-500 mt-1 truncate font-mono">/{p.slug}</div>
              </div>
              <span className="text-[0.6rem] font-bold tracking-[0.22em] uppercase text-neutral-500 shrink-0">
                {p.industry}
              </span>
              <span className="text-[0.6rem] font-bold tracking-[0.22em] uppercase text-neutral-500 shrink-0">
                Var · {p.variant}
              </span>
              <span
                className={`text-[0.6rem] font-bold tracking-[0.22em] uppercase px-2 py-1 rounded shrink-0 ${
                  p.published
                    ? "bg-[#F4D64E]/15 text-[#F4D64E]"
                    : "bg-white/[0.05] text-neutral-500"
                }`}
              >
                {p.published ? "Live" : "Draft"}
              </span>
              <Btn variant="ghost" onClick={() => onDuplicate(p.slug)} data-testid={`cs-dup-${p.slug}`}>Duplicate</Btn>
              <Btn variant="danger" onClick={() => setConfirmDel(p)} data-testid={`cs-del-${p.slug}`}>Delete</Btn>
            </li>
          ))}
        </ul>
      )}

      <ConfirmDialog
        open={!!confirmDel}
        title="Delete this case study?"
        message={`This will permanently remove "${confirmDel?.name}". Cannot be undone.`}
        onConfirm={onDelete}
        onCancel={() => setConfirmDel(null)}
        danger
      />
    </div>
  );
}
